if(document.querySelectorAll('.swiper-container').length) {
  try {
    var swiper = new Swiper ('.swiper-container', {
      slidesPerView: 1,
      spaceBetween: 0,
      direction: 'horizontal',
      loop: true,

      breakpoints: {
        640: {
          slidesPerView: 2,
        },

        1024: {
          slidesPerView: 3,
        },

        1120: {
          slidesPerView: 4,
        }
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
  } catch (e) {
    console.log(e);
  }
}